<template>
  <div :class="disFullYear ? 'price-box-large' : 'price-box'">
    <div class="price-box--container">
      <div v-if="prices" class="price-box--selector">
        <!-- monthly||annual payment option  -->
        <!-- if form === join render below else  -->
        <div>
          <div class="price-box--buttons">
            <template v-if="isLockedToAnnual">
              <div class="price-box--button-full">
                <span>Annual</span>
              </div>
            </template>
            <template v-else-if="isLockedToMonthly">
              <div class="price-box--button-full">
                <span>Monthly</span>
              </div>
            </template>
            <template v-for="t in types" v-else>
              <div
                v-if="prices[t.key]"
                :key="`pt-${t.key}`"
                class="price-box--button"
                @click.prevent="$set(data, 'payment', t.key)"
                :class="{ active: data.payment === t.key }"
              >
                <span>{{ t.label }}</span>
              </div>
            </template>
          </div>
        </div>
        <div class="price-box--price">
          <div class="price-box--content">
            <div
              class="price-box--price-value"
              v-if="
                formType === 'renew' && user['state'] === 'NSW' && user['balance']
              "
            >
              <template v-if="data.payment == 'M'">
                {{ prices[data.payment]["price"] | currency(discount) }}
              </template>
              <template v-else>
                {{ user["balance"].toFixed(2) | currency(discount) }}
              </template>
            </div>
            <div class="price-box--price-value" v-else-if="formType === 'renew' && user['state'] === 'SA'">
              <template>
                {{ prices[data.payment]["price"] | currency(discount) }}
              </template>
            </div>
            <div class="price-box--price-value" v-else>
              <template v-if="cpd">
                {{ prices["A"]["price"] | currency(discount) }}
              </template>
              <template v-else>
                {{ prices[data.payment]["price"] | currency(discount) }}
              </template>
            </div>
            <span v-if="data.payment == 'M'">per month</span>
            <!-- <span v-if="formType === 'join' && data.promoteCode == 'AMANSW25'">Until end of 2026</span> -->
            <span v-else-if="fullYear">per year</span>
            <span v-else-if="disFullYear" class="fullyear-dis">Annual membership fee <span>(Paid through to 31/12/2025)</span></span>
            <span v-else-if="fullYearNSW">Until end of 2026</span>
            <span v-else>for remainder of {{ new Date().getFullYear() }}</span>
            <!-- <span v-else-if="data.payment != 'M' && user['state'] === 'NSW'">Until end of 2026</span> -->
          </div>
          <!-- <p v-if="cpd" class="price-box--cpd">
            + CPD subscription <br /><span>One-time payment of $220</span>
          </p> -->
        </div>
        
      </div>
      <div v-else class="price-box--selector">
        <strong> - Select a membership - </strong>
      </div>
      <div class="price-box--membership">
        <div class="price-box--membership-title">
          Membership category
          <a
            v-if="renew && !selectMembership && user['state'] !== 'NSW' && user['state'] !== 'SA'"
            href="#"
            @click.prevent="$emit('change')"
            >(Change)</a
          >
        </div>
        <div class="price-box--membership-data">
          <div class="price-box--membership-value">{{ membership.key }}</div>
          <div
            class="price-box--membership-label"
            v-if="formType === 'upgrade' && membership.key === 'F1Y1'"
          >
            Intern
          </div>
          <div
            class="price-box--membership-label"
            v-else-if="formType === 'renew' && membership.key === 'FBB1' && user['state'] === 'SA'"
          >
            Overseas
          </div>
          <div class="price-box--membership-label" v-else>
            {{ membership.label }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="cpd" class="price-box--cpd-total">
      <hr>
      <p>Total: ${{ prices["A"]["price"] | cpdTotal(cpd) }}</p>
    </div>
    <div v-if="formType !== 'upgrade'" class="price-box--info">
        <div class="tax-tooltip" tabindex="0">
          <span class="info-icon" tabindex="0" v-tooltip.top="tooltip" aria-label="More info">
            <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            >
            <path
            d="M11 7H13V9H11V7ZM11 11H13V17H11V11ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
            fill="#0339A6"
            />
            </svg>
          </span>
          <div class="tax-tooltip__box" v-html="tooltipText" role="tooltip" aria-hidden="true"></div>
          <span class="tax-tooltip__trigger">Federal AMA membership is tax deductible</span>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "price-box",
  props: [
    "form",
    "prices",
    "options",
    "renew",
    "discount",
    "formType",
    "selectMembership",
    "user",
    "cpd",
  ],
  data() {
    return {
      tooltipText:
        "You can claim a deduction for the cost of membership with the Australian Medical Association (AMA) to reduce your taxable income.",  
      types: [
        { key: "M", label: "Monthly" },
        { key: "F", label: "Fortnightly" },
        { key: "Q", label: "Quarterly" },
        { key: "A", label: "Annual" },
      ],
      data: {
        payment: "M",
      },
    };
  },
  filters: {
    cpdTotal(value, check) {
      if (check) {
        var total = (value + 220).toFixed(2);
        return total;
      }
    },
    currency(value, discount) {
      var vdiscount = 1 - parseFloat(discount).toFixed(2);
      return `$${(parseFloat(value) * vdiscount).toFixed(2)}`;
    },
  },
  computed: {
    disFullYear() {
      var year = new Date().getFullYear();
      
      if(this.formType == 'join' && year < 2025 && this.data.payment == 'A') {
        return true;
      }
      

      return this.renew;
    },
    fullYear() {
      if (window.metadata.year != new Date().getFullYear()) {
        return true;
      }

      if (this.data.state == "SA" && this.renew) {
        return true;
      }

      return this.renew;
    },
    fullYearNSW() {
      if (this.data.state == "NSW" && this.data.payment === "A") {
        return true;
      }

      return this.renew;
    },
    membership() {
      const { stage, employment, membership, state } = this.data;
      //This is F1PT membership
      
      const dit_intern = this.data.dit_intern;
      if (dit_intern) {
        return {
          key: "F1PT",
          label: "Doctor in training - Part time",
        };
      }
      if (this.form.offerdiscount == "internWebinar2024") {
        return {
          key: "F1Y1 - 25% OFF",
          label: "Doctor in training - Discount",
        };
      }
      if (this.form.promoteCode == 'AMANSW25') {
        const memberships = this.options.memberships['NSWP'];
        const available =
          memberships[stage]["arrangement"][employment]["options"];
        let current = available.find((m) => m.key == membership);
        if (current) {
          current = { ...current, label: memberships[stage]["label"] };
          return current;
        }
      }

      //Special retain form selection
      if (this.formType == 'renew' && (state =='QLD' || state =='WA' || state == 'VIC')) {
        if(!stage || !employment || !this.options) {
          return {
            key: "", label: "",
          };
        }
        if (membership === 'FPP1') {
          return {
            key: membership, label: "General Practitioner",
          };
        }
        const specialFullTimeStages = ['aop', 'pgp', 'pps', 'phd', 'phs'];

        const memberships = this.options.memberships[state];
        console.log("memberships in price box:", memberships, ", stage:", stage, ", employment:", employment, 'membership:', membership);
        const available =
          memberships[stage]["arrangement"][employment]["options"];
        let current = available.find((m) => m.key == membership);
        if (stage === 'gpr' && membership === '') {
          current = available.find((m) => m.key == this.user.membership);
        }
        console.log("current membership before label adjustment:", current, ', available based on membership:', available);
        if (current) {
          if (employment !== 'fullTime' && specialFullTimeStages.includes(stage)) { current = { ...current, label: memberships[stage]["arrangement"][employment]["label"] };}
          else if(employment === 'fullTime' && specialFullTimeStages.includes(stage)) current = { ...current, label: memberships[stage]["label"] };
          console.log("current membership price box:", current);
          return current;
        }
      }
      
      //Normal membership selection
      if (stage && employment && this.options) {
        const memberships = this.options.memberships[state];
        const available =
          memberships[stage]["arrangement"][employment]["options"];
        let current = available.find((m) => m.key == membership);
        if (current) {
          current = { ...current, label: memberships[stage]["label"] };
          return current;
        }  
      }

      return {
        key: "",
        label: "",
      };
    },
    isLockedToAnnual() {
      return (this.renew && this.user.state == "SA") || (this.formType === "join" && this.data.state == "NSW" && this.data.promoteCode == "AMANSW25");
    },
    isLockedToMonthly() {
      return (this.formType === "upgrade" && this.user.state == "NSW");
    },
  },
  methods: {},
  mounted() {
    this.data = this.form;
    console.log("price box mounted", this.data);
    //console.log("user data in price box:", this.user);
    console.log("price:", this.prices);
    
    if (this.formType === 'renew' && (this.user.state === "QLD" || this.user.state === "WA" || this.user.state === "VIC")) {
      if(this.data.membership === '') this.data.membership = this.user.membership;
      if(this.data.employment === '') this.data.employment = this.user.employment;
      if(this.data.stage === '') this.data.stage = this.user.stage;
    }
  },
};
</script>
<style scoped>
.price-box {
  background: #e6ebf6;
  border-radius: 1rem;
  padding: 1rem;
  display: flex;
  margin-bottom: 2rem;
  flex-direction: column;
}
.price-box-large {
  background: #e6ebf6;
  border-radius: 1rem;
  padding: 1rem;
  display: flex;
  margin-bottom: 2rem;
  flex-direction: column;
  width: auto; 
}
.price-box--selector {
  margin-right: 2rem;
  width: 50%;
}

.price-box--buttons {
  display: flex;
  border: 1px solid #0339a6;
  border-radius: 99px;
}

.price-box--container {
  display: flex;
}

.price-box--button {
  width: 50%;
  padding: 0.25rem 0;
  text-align: center;
  font-weight: 500;
  font-size: 0.625rem;
  line-height: 12px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #0339a6;
  cursor: pointer;
}
.price-box--button-full {
  width: 190%;
  padding: 0.25rem 0;
  text-align: center;
  font-weight: 700;
  font-size: 0.625rem;
  line-height: 12px;
  text-align: center;
  letter-spacing: -0.02em;
  background: #0033ab;
  color: #ffffff;
  cursor: pointer;
  border-radius: 99px;
}

.price-box--button.active {
  background: #0339a6;
  font-weight: 700;
  color: #ffffff;
  border-radius: 99px;
}

.price-box--price {
  margin: 0.5rem 1rem;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.price-box--price-value {
  font-weight: 700;
  font-size: 2rem;
  line-height: 39px;
  letter-spacing: -0.02em;
  color: #424242;
}

.price-box--price span {
  margin-left: 0.5rem;
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 15px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #424242;
}

.price-box--info {
  font-size: 0.75rem;
  line-height: 15px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #0339a6;
  margin-top: 1rem;
}

.price-box--cpd {
  font-weight: 600;
  font-size: 0.9rem;
  color: #424242;
  text-align: center;
}

.price-box--cpd span {
  font-size: 0.7rem;
}

.price-box--info span {
  display: inline-block;
  vertical-align: center;
}

.price-box--info span + span {
  margin-left: 0.5rem;
}

.price-box--membership {
  display: flex;
  flex-direction: column;
}

.price-box--membership-title {
  font-weight: 700;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: -0.02em;
  color: #424242;
  margin-top: 0.25rem;
}

.price-box--membership-title a {
  color: #0033ab;
  text-decoration: none;
  font-weight: 500;
}

.price-box--membership-title a:hover {
  text-decoration: underline;
}

.price-box--membership-data {
  margin-top: 1rem;
}

.price-box--membership-value {
  font-weight: 700;
  font-size: 1rem;
  line-height: 19px;
  letter-spacing: -0.02em;
  color: #424242;
  margin-bottom: 0.25rem;
}

.price-box--membership-label {
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 15px;
  letter-spacing: -0.02em;
  color: #424242;
}
.price-box--content {
  display: flex;
  align-items: center;
}

.price-box--cpd-total {
    text-align: center;
    font-weight: bold;
    color: #424242;
    font-size: 1.5rem;
}

.price-box--cpd-total p{
  margin-bottom: 0;
}

.price-box--cpd-total hr {
  margin-top: 0;
}

.fullyear-dis {
  width: 110px;
  font-size: 0.63rem !important;
}

.fullyear-dis span{
  width: 110px; 
  display: block; 
  font-size: 0.53rem; 
  margin-left: 0px;
}

/* Tooltip wrapper for the text */
.tax-tooltip {
  position: relative;
  display: inline-block;
  cursor: default;
  outline: none;
}

/* trigger text style */
.tax-tooltip__trigger {
  color: #0339a6;
  font-weight: 500;
  font-size: 0.75rem;
  margin-left: .5rem;
}

/* hidden tooltip box */
.tax-tooltip__box {
  position: absolute;
  left: 50%;
  transform: translateX(-50%) translateY(8px);
  top: 100%;
  white-space: normal;
  width: 260px;
  background: #ffffff;
  color: #333;
  border: 1px solid #e0e0e0;
  box-shadow: 0 6px 18px rgba(3,57,166,0.12);
  padding: 8px 10px;
  border-radius: 6px;
  font-size: 0.75rem;
  line-height: 1.2;
  text-align: left;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.15s ease, transform 0.15s ease;
  z-index: 30;
}

/* show on hover or keyboard focus of the svg icon only */
.info-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  outline: none;
}
.info-icon:focus {
  outline: none;
}
.info-icon:hover + .tax-tooltip__box,
.info-icon:focus + .tax-tooltip__box {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(12px);
}

/* small arrow (optional) */
.tax-tooltip__box::before {
  content: "";
  position: absolute;
  top: -6px;
  left: 50%;
  transform: translateX(-50%);
  border-width: 6px;
  border-style: solid;
  border-color: transparent transparent #ffffff transparent;
  filter: drop-shadow(0 -1px 0 rgba(0,0,0,0.03));
}

</style>
